module.exports = __webpack_public_path__ + "img/right-arrow.c5d13250.svg";